export const propertyNames = {
    PROPERTY_SITE_ID: 'SITE_ID',
    PROPERTY_SERIAL_NUMBER: 'SERIAL_NUMBER',
};
